import React from 'react';
import {Redirect, Route} from "react-router-dom";
import {RouteComponentProps, StaticContext} from "react-router";
import {useSelector} from "react-redux";
import {StateType} from "../store/store";

type RouteProps = {
  [x: string]: any,
  component: React.ComponentType<any> | React.ComponentType<RouteComponentProps<any, StaticContext, unknown>>
}

export default function ClassPrivateRoute({component: Component, ...rest}: RouteProps) {
  const {studentReducer, teacherReducer} = useSelector((state: StateType) => state.rootReducer);

  return (
    <Route
      {...rest}
      render={(props =>
          studentReducer.data.role === "student" || teacherReducer.data.role === "teacher" ? (
            <Component {...props} />
          ) : (
            <Redirect to={{pathname: "/auth"}}/>
          )
      )}
    />
  )
}